import { PLANY_CARE_APP } from "./plany-care/appDefinition";
import { APP_IDS } from "./shared/appIds";
import { TIMELY_APP } from "./shared/timelyProviderDefinition";

export { APP_IDS };

export const APP_DEFINITIONS = Object.freeze({
  [APP_IDS.PLANY_CARE]: PLANY_CARE_APP,
  [APP_IDS.TIMELY]: TIMELY_APP,
});

export const TIMELY_HOSTS = new Set(TIMELY_APP.hosts);


export function normalizeHostname(hostname) {
  return String(hostname || "").trim().toLowerCase();
}

export function getRuntimeAppId(hostname) {
  return APP_IDS.PLANY_CARE;
}

export function getRuntimeAppProfile(hostname) {
  const resolvedHostname =
    hostname ??
    (typeof window !== "undefined" ? window.location.hostname : "");
  return APP_DEFINITIONS[getRuntimeAppId(resolvedHostname)];
}

export function isTimelyRuntime(hostname) {
  return getRuntimeAppId(hostname) === APP_IDS.TIMELY;
}

export function isPlanyCareRuntime(hostname) {
  return getRuntimeAppId(hostname) === APP_IDS.PLANY_CARE;
}

export function shouldShowProductSwitcher() {
  return false;
}

export function getRuntimePublicHomePath(hostname) {
  return getRuntimeAppProfile(hostname).publicHomePath;
}

export function getRuntimeBusinessHomePath(hostname) {
  return getRuntimeAppProfile(hostname).businessHomePath;
}

function matchesRoutePrefix(pathname, prefix) {
  return pathname === prefix || pathname.startsWith(`${prefix}/`);
}

export function getOwningAppIdForPath(pathname) {
  const normalizedPath = String(pathname || "/").split("?")[0];
  const owner = Object.values(APP_DEFINITIONS).find((app) =>
    app.ownsRoutePrefixes.some((prefix) => matchesRoutePrefix(normalizedPath, prefix))
  );
  return owner?.id || null;
}

export function getCrossAppUrl(pathname, search = "", hostname) {
  const resolvedHostname = normalizeHostname(
    hostname ??
      (typeof window !== "undefined" ? window.location.hostname : "")
  );
  const owningAppId = getOwningAppIdForPath(pathname);
  const runtimeAppId = getRuntimeAppId(resolvedHostname);
  if (!owningAppId || owningAppId === runtimeAppId) return null;

  const normalizedPath = String(pathname || "/").startsWith("/")
    ? String(pathname || "/")
    : `/${pathname}`;
  const normalizedSearch = search && !String(search).startsWith("?")
    ? `?${search}`
    : String(search || "");

  const isLocal = new Set(["localhost", "127.0.0.1", "::1"]).has(resolvedHostname);
  if (isLocal) {
    const protocol =
      typeof window !== "undefined" && window.location?.protocol
        ? window.location.protocol
        : "http:";
    const targetPort = owningAppId === APP_IDS.TIMELY ? "3001" : "3000";
    const localHost = resolvedHostname === "::1" ? `[${resolvedHostname}]` : resolvedHostname;
    return `${protocol}//${localHost}:${targetPort}${normalizedPath}${normalizedSearch}`;
  }

  if (!resolvedHostname) return null;
  const targetHost = APP_DEFINITIONS[owningAppId].publicHost;
  return `https://${targetHost}${normalizedPath}${normalizedSearch}`;
}
